/* src/app/shared/contract/contract-item/contract-general-informations/contract-advertising-center-group/contract-advertising-center-group.component.scss */
.category-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.data-container {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
.data-title {
  display: flex;
  gap: 5px;
  background-color: rgba(107, 144, 179, 0.05);
  font: 400 15px FranceTV Brown;
  color: #6B90B3;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
}
/*# sourceMappingURL=contract-advertising-center-group.component.css.map */
